<template>
    <br/>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="search" class="form-label mt-2 me-2">Keyword</label>
        <input type="text" id="search" class="form-control" placeholder="Post title" v-model="keyword"
               @input="searchKeyword"/>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-1 mt-2">Type</label>
        <select id="per-page" class="form-control" v-model="type" @change="changeType(type)">
          <option value="">All</option>
          <option value="audio">Audio</option>
          <option value="fundraiser">Fundraiser</option>
          <option value="photo">Image</option>
          <option value="livestream">Livestream</option>
          <option value="poll">Poll</option>
          <option value="text">Text</option>
          <option value="video">Video</option>
          <option value="vimeo">Vimeo</option>
          <option value="youtube">Youtube</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="status" class="form-label me-1 mt-2">Post status</label>
        <select id="status" class="form-control" v-model="status" @change="changeStatus()">
          <option value="">-</option>
          <option style="text-transform: capitalize;" v-for="postStatus in postStatuses" :value="postStatus" :key="postStatus">{{ postStatus }}</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="ai-moderation-status" class="form-label me-1 mt-2">AI Moderation status</label>
        <select id="ai-moderation-status" class="form-control" v-model="aiModerationStatus" @change="changeAiModerationStatus()">
          <option value="">-</option>
          <option v-for="moderationStatus in sentibeeStatuses" :key="moderationStatus" :value="moderationStatus">{{ moderationStatusLabel(moderationStatus) }}</option>
        </select>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-1 mt-2">Per page</label>
        <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
      </div>
    <div class="table-responsive container-fluid">
      <div class="alert alert-success" role="alert" v-if="successAlert">
        {{ successAlert}}
      </div>
      <div class="alert alert-danger" role="alert" v-if="errorAlert">
        {{ errorAlert}}
      </div>
      <h4 class="text-center">{{this.channelName}} Posts</h4>
      <router-link :to="{name: 'SingleChannel', params: {id: this.$route.params.id}}">Back to creator</router-link>
      <table class="table">
        <thead>
        <tr>
          <th scope="col"># ID</th>
          <th scope="col">Title (link)</th>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Access type</th>
          <th scope="col">Categories</th>
          <th scope="col">Price</th>
          <th scope="col">Is draft</th>
          <th scope="col">Is published</th>
          <th scope="col">Post status</th>
          <th scope="col">Sentibee (AI) result</th>
          <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="12" class="text-center"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin/></td>
        </tr>
        <tr v-else-if="posts.length === 0">
          <td colspan="12" class="text-center">No posts</td>
        </tr>
        <tr v-else v-for="post in posts" :key="post.id">
          <th scope="row">{{post.id}}</th>
          <td><a :href="post.link" target='_blank'>{{post.title}}</a></td>
          <td>{{post.date}}</td>
          <td>{{post.type}}</td>
          <td>
            {{post.access_type}}
            <div v-if="post.access_tiers_name" v-for="tier_name in post.access_tiers_name">
              <div>
                ({{ tier_name }})
              </div>
            </div>
          </td>
          <td>
            <div v-if="post.categories_name.length > 0" v-for="category in post.categories_name">
              <div>
                {{ category.name }}
              </div>
            </div>
            <div v-else>
              None
            </div>
          </td>
          <td>{{post.price / 100}} {{ post.channel_data.currency }}</td>
          <td>{{post.draft ? 'yes' : 'no'}}</td>
          <td>{{this.todaysDateString >= post.date ? 'yes' : 'no'}}</td>
          <td>
            <span v-if="post.status">
              <span v-if="post.status.toLowerCase() === 'approved'" class="badge badge-success text-capitalize">{{ post.status }}</span>
              <span v-else-if="post.status.toLowerCase() === 'rejected'" class="badge badge-danger text-capitalize">{{ post.status }}</span>
              <span v-else-if="post.status.toLowerCase() === 'pending'" class="badge badge-warning text-capitalize">{{ post.status }}</span>
              <span v-else class="badge badge-secondary text-capitalize">{{ post.status }}</span>
            </span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="post.moderation_ai_result">
              <span v-if="post.moderation_ai_result.status">
                <span v-if="post.moderation_ai_result.status.toLowerCase() === 'approved'" class="badge badge-success text-capitalize text-underline" style="cursor: pointer;" @click="showAiModerationModal(post.moderation_ai_result)">Approved</span>
                <span v-else-if="post.moderation_ai_result.status.toLowerCase() === 'reviewed_ok'" class="badge badge-success text-capitalize text-underline" style="cursor: pointer;" @click="showAiModerationModal(post.moderation_ai_result)">Reviewed - OK</span>
                <span v-else-if="post.moderation_ai_result.status.toLowerCase() === 'flagged'" class="badge badge-warning text-capitalize text-underline" style="cursor: pointer;" @click="showAiModerationModal(post.moderation_ai_result)">Low risk</span>
                <span v-else-if="post.moderation_ai_result.status.toLowerCase() === 'rejected'" class="badge badge-danger text-capitalize text-underline" style="cursor: pointer;" @click="showAiModerationModal(post.moderation_ai_result)">High risk</span>
                <span v-else>{{ post.moderation_ai_result.status }}</span>
              </span>
              <span class="badge badge-info" v-else>Not Available</span>
            </span>
            <span class="badge badge-info" v-else>Not Available</span>
          </td>
          <td>
            <div class="btn-group-sm d-flex gap-3" role="group">
              <button v-if="post.status !== 'approved'" @click="approvePost(post.id)" class="btn btn-success">Approve</button>
              <button v-if="post.status === 'pending'" @click="restrictPost(post.id, post.restricted_post?.reason ?? '', post.restricted_post?.details ?? '', post.channel_data?.user_data?.locale ?? 'en')" class="btn btn-warning">Restrict again</button>
              <button v-else-if="post.status !== 'restricted'" @click="restrictPost(post.id, post.restricted_post?.reason ?? '', post.restricted_post?.details ?? '', post.channel_data?.user_data?.locale ?? 'en')" class="btn btn-warning">Restrict</button>
              <button @click="deletePost(post.id)" class="btn btn-danger">Delete</button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
        <div>
          <div class="p-2">
            <p>Total posts: {{ totalRecords }}</p>
          </div>
        </div>
        <div>
          <div class="p-2">
            <nav v-if="totalPages >= 1" aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                  <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
                </li>
                <li class="page-item" :class="{active: 1 === currentPage}">
                  <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
                </li>
                <li class="page-item" v-if="currentPage - 2 > 1">
                  <a href="#" class="page-link">...</a>
                </li>
                <li class="page-item" v-if="currentPage - 2 > 1">
                  <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
                </li>
                <li class="page-item" v-if="currentPage - 1 > 1">
                  <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
                </li>
                <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                  <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
                </li>
                <li class="page-item" v-if="currentPage + 1 <= totalPages">
                  <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
                </li>
                <li class="page-item" v-if="currentPage + 2 <= totalPages">
                  <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
                </li>
                <li class="page-item" v-if="currentPage + 2 < totalPages">
                  <a href="#" class="page-link">...</a>
                </li>
                <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                  <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
                </li>
                <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                  <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios';
  import _debounce from "lodash/debounce";
  import Swal from "sweetalert2";
  
  export default {
    data() {
      return {
        loading: true,
        disableExport: false,
        type: '',
        keyword: '',
        posts: [],
        channelName: '',
        todaysDateString: '',
        status: '',
        aiModerationStatus: '',
        currentPage: 1,
        totalPages: 0,
        totalRecords: 0,
        perPage: 20,
        postStatuses: [],
        sentibeeStatuses: [],
        postRestrictionReasons: [],
        successAlert: '',
        errorAlert: ''
      }
    },
  
    mounted() {
      this.restrictReasons();
      this.getPostStatuses();
      this.getSentibeeStatuses();
      this.todaysDate();
      this.fetchChannelName();
      this.getPosts('', '', 1, 20, this.status, this.aiModerationStatus);
    },

    methods: {
      debounceGetPosts: _debounce(function (keyword, type,  page, perPage, status, aiModerationStatus) {
        this.loading = true;
        axios.get(`/admin/posts/channel/${this.$route.params.id}?keyword=${keyword}&type=${type}&page=${page}&per_page=${perPage}&status=${status}&ai_moderation_status=${aiModerationStatus}`).then(response => {
          this.posts = response.data.data;
          this.totalPages = response.data.totalPages;
          this.totalRecords = response.data.totalRecords;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
      }, 500),
      getPosts(keyword, type,  page, perPage, status, aiModerationStatus = this.aiModerationStatus) {
        this.loading = true;
        this.debounceGetPosts(keyword, type, page, perPage, status, aiModerationStatus);
      },
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      customDate(date) {
        let dateValue = this[date];

        // Check if the input is a valid date
        if (dateValue) {
          // Convert the input to a Date object
          const dateObject = new Date(dateValue);
          this[date] = this.formatDate(dateObject);
        }
      },
      searchDate(date) {
        this.date = date;
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type, this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      changeType(type) {
        this.type = type;
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      changeStatus() {
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      changeAiModerationStatus() {
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      searchKeyword() {
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type, this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      perPageFilter(perPage) {
        this.perPage = perPage;
        this.currentPage = 1;
        this.getPosts(this.keyword, this.type, this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      paginate(page) {
        this.currentPage = page;
        this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
      },
      fetchChannelName() {
          axios.get(`/admin/channel-name/${this.$route.params.id}`)
          .then(response => {
            this.channelName = response.data.data;
          })
          .catch(error => {
            this.channelName = '-';
          });
      },
      getPostStatuses() {
        axios.get('/admin/posts/statuses').then(response => {
          this.postStatuses = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSentibeeStatuses() {
        axios.get('/admin/sentibee/statuses').then(response => {
          this.sentibeeStatuses = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      moderationStatusLabel(status) {
        if (!status) return '-';

        const lowerStatus = status.toLowerCase();
        if (lowerStatus === 'approved') {
          return 'Approved';
        } else if (lowerStatus === 'flagged') {
          return 'Low risk';
        } else if (lowerStatus === 'rejected') {
          return 'High risk';
        }

        return status.charAt(0).toUpperCase() + status.slice(1);
      },
      todaysDate() {
        let date = new Date();

        let year = date.getFullYear();

        let month = (date.getMonth() + 1).toString().padStart(2, '0');

        let day = date.getDate().toString().padStart(2, '0');

        let hours = date.getHours().toString().padStart(2, '0');

        let minutes = date.getMinutes().toString().padStart(2, '0');

        this.todaysDateString = `${year}-${month}-${day} ${hours}:${minutes}`
      },
      showAiModerationModal(aiResult) {
        if (!aiResult) return;

        let scoresContent = '';
        if (aiResult.scores && typeof aiResult.scores === 'object') {
          const rows = Object.entries(aiResult.scores)
            .map(([category, score]) => {
              const label = category
                .replace(/_/g, ' ')
                .replace(/\b\w/g, l => l.toUpperCase());
              return `<tr><td style="text-align: left; padding: 6px 12px; border-bottom: 1px solid #dee2e6;"><strong>${label}</strong></td><td style="text-align: right; padding: 6px 12px; border-bottom: 1px solid #dee2e6;">${score}%</td></tr>`;
            })
            .join('');

          scoresContent = `
            <div style="margin-top: 15px;">
              <h6 style="text-align: left; font-weight: 600; margin-bottom: 8px;">Scores</h6>
              <table class="table table-sm" style="width: 100%; margin-bottom: 0;">
                <tbody>
                  ${rows}
                </tbody>
              </table>
            </div>
          `;
        }

        const confidence = aiResult.confidence !== undefined && aiResult.confidence !== null ? `${aiResult.confidence}%` : '-';
        const status = this.moderationStatusLabel(aiResult.status);
        const sentibeeLink = aiResult.sentibee_link ? aiResult.sentibee_link : '';
        const contribeeLink = aiResult.contribee_link ? aiResult.contribee_link : '';
        const ulid = aiResult.sentibee_content_item_ulid || '';

        const statusOptions = this.sentibeeStatuses.map(moderationStatus => {
          const selected = aiResult.status && aiResult.status.toLowerCase() === moderationStatus.toLowerCase() ? 'selected' : '';
          return `<option value="${moderationStatus}" ${selected}>${this.moderationStatusLabel(moderationStatus)}</option>`;
        }).join('');

        Swal.fire({
          title: 'AI Moderation Details',
          html: `
            <div style="text-align: left;">
              <p style="margin-bottom: 6px;"><strong>Status:</strong> ${status}</p>
              <p style="margin-bottom: 6px;"><strong>Confidence:</strong> ${confidence}</p>
              <p style="margin-bottom: 6px;"><strong>Sentibee link:</strong> <a href="${sentibeeLink}" target="_blank">Open</a></p>
              <p style="margin-bottom: 6px;"><strong>Contribee link:</strong> <a href="${contribeeLink}" target="_blank">Open</a></p>
              ${scoresContent}
              <div style="margin-top: 15px;">
                <h6 style="text-align: left; font-weight: 600; margin-bottom: 8px;">Override status</h6>
                <select id="ai-moderation-status-update" class="swal2-select" style="display:block;width:100%;margin:0 auto;">
                  ${statusOptions}
                </select>
              </div>
            </div>
          `,
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Update status',
          cancelButtonText: 'Close',
          confirmButtonColor: '#3085d6',
          preConfirm: () => {
            return document.getElementById('ai-moderation-status-update').value;
          }
        }).then(async (result) => {
          if (!result.isConfirmed || !ulid) return;

          await axios.patch(
            '/admin/sentibee/status',
            {
              ulid: ulid,
              status: result.value
            }
          ).then(() => {
            this.successAlert = 'AI moderation status updated successfully.';
            this.getPosts(this.keyword, this.type, this.currentPage, this.perPage, this.status, this.aiModerationStatus);
          })
          .catch(error => {
            this.errorAlert = error.response?.data?.message || 'An error occurred while updating the AI moderation status.';
          });
        });
      },
      restrictReasons() {
        axios.get('/admin/posts/restrict/reasons').then(response => {
          this.postRestrictionReasons = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      async approvePost(postId) {
        this.clearAlerts();
        const warning = await Swal.fire({
          title: 'Approve post',
          text: 'Are you sure you want to approve this post?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        })

        if(warning.isConfirmed) {
          await axios.post(
            `/admin/posts/approve`,
            {
              post_id: postId
            }
          ).then(response => {
            this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
            this.successAlert = 'Post approved successfully.';
          })
          .catch(error => {
            this.errorAlert = error.response?.data?.message || 'An error occurred while approving the post.';
          });
        }

      },
      async restrictPost(postId, reason = '', details = '', locale = 'en') {
        this.clearAlerts();
        const options = Object.entries(this.postRestrictionReasons || {}).map(([value, label]) => {

          if(value === reason) {
            return `<option value="${value}" selected>${label}</option>`;
          }

          return `<option value="${value}">${label}</option>`;
        }).join('');

        const warning = await Swal.fire({
          title: 'Restrict post',
          html: `
            <select id="restrict-reason" class="swal2-select" style="display:block;width:100%;margin:1em auto;">
              <option value="">Select reason</option>
              ${options}
            </select>
             <p>If details are provided, please use <span class="text-uppercase text-primary">${locale}</span> langauge</p>
            <textarea id="restrict-details" class="swal2-textarea" placeholder="Add details" style="display:block;width:100%;margin:1em auto;">${details}</textarea>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          preConfirm: () => {
            const reason = document.getElementById('restrict-reason').value;
            const details = document.getElementById('restrict-details').value;

            if (!reason) {
              Swal.showValidationMessage('Please select a reason');
              return false;
            }

            return { reason, details };
          }
        })

        if(warning.isConfirmed) {
          await axios.post(
            `/admin/posts/restrict`,
            {
              post_id: postId,
              reason: warning.value.reason,
              details: warning.value.details
            }
          ).then(response => {
            this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
            this.successAlert = 'Post restricted successfully.';
          })
          .catch(error => {
            this.errorAlert = error.response?.data?.message || 'An error occurred while restricting the post.';
            console.log(error);
          });
        }

      },
      async deletePost(postId) {
        this.clearAlerts();
        const warning = await Swal.fire({
          title: 'Delete post',
          html: `
            <p>Are you sure you want to delete this post?</p>
            <textarea id="delete-reason" class="swal2-textarea" placeholder="Enter delete reason" style="display:block;width:100%;margin:1em auto;"></textarea>
          `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          preConfirm: () => {
            const reason = document.getElementById('delete-reason').value.trim();

            if (!reason) {
              Swal.showValidationMessage('Please enter a delete reason');
              return false;
            }

            return { reason };
          }
        });

        if(warning.isConfirmed) {
          await axios.delete(
            `/admin/post`,
            {
              data: {
                post_id: postId,
                reason: warning.value.reason
              }
            }
          ).then(response => {
            this.getPosts(this.keyword, this.type,  this.currentPage, this.perPage, this.status, this.aiModerationStatus);
            this.successAlert = 'Post deleted successfully.';
          })
          .catch(error => {
            this.errorAlert = error.response?.data?.message || 'An error occurred while deleting the post.';
            console.log(error);
          });
        }
      },
      clearAlerts() {
        this.successAlert = '';
        this.errorAlert = '';
      }
    }
  }
  </script>
  